/* FUKUI — shop policies
   Shopify renders the legal pages itself, so the theme never gets to write
   their markup. This takes whatever Shopify emits and gives it the same
   structure as the rest of the site: numbered sections, a sticky contents
   column and a help card. It only ever moves and labels what is already on
   the page — no wording is added, removed or changed.

   Two shapes turn up in practice: documents written with real headings, and
   documents written as a flat run of paragraphs with a bold lead-in. Real
   headings win; the bold lead-ins are only read when there are none. */
(function () {
  'use strict';

  var container = document.querySelector('.shopify-policy__container');
  var bodyEl = document.querySelector('.shopify-policy__body');
  if (!container || !bodyEl) return;

  var rte = bodyEl.querySelector('.rte') || bodyEl;
  var titleWrap = document.querySelector('.shopify-policy__title');
  document.body.classList.add('policy-page');

  var lead = null;

  /* ── 0. one enormous paragraph held together by <br> ───────── */
  /* Shopify's stock Terms of Service arrives as a single <p> of several
     thousand words. Split it at blank lines so the structure below it can be
     seen at all; single breaks are kept as breaks. */
  if (rte.children.length <= 2 && rte.querySelector('br')) {
    Array.prototype.slice.call(rte.children).forEach(function (p) {
      if (p.tagName !== 'P' || p.querySelectorAll('br').length < 4) return;
      var out = document.createDocumentFragment();
      var para = document.createElement('p');
      var pending = 0;
      Array.prototype.slice.call(p.childNodes).forEach(function (node) {
        if (node.nodeType === 1 && node.tagName === 'BR') {
          pending++;
          if (pending >= 2 && para.textContent.trim()) {
            out.appendChild(para);
            para = document.createElement('p');
            pending = 0;
          }
          return;
        }
        if (node.nodeType === 3 && !node.textContent.trim()) return;
        if (pending === 1) para.appendChild(document.createElement('br'));
        pending = 0;
        para.appendChild(node);
      });
      if (para.textContent.trim()) out.appendChild(para);
      p.parentNode.replaceChild(out, p);
    });
  }

  /* ── 1a. the document already has headings ─────────────────── */
  var native = Array.prototype.slice.call(rte.children).filter(function (el) {
    return /^H[1-4]$/.test(el.tagName);
  });

  if (native.length >= 2) {
    var byTag = {};
    native.forEach(function (el) { byTag[el.tagName] = (byTag[el.tagName] || 0) + 1; });
    var level = Object.keys(byTag).sort(function (a, b) {
      return byTag[b] - byTag[a] || a.localeCompare(b);
    })[0];

    native.forEach(function (el) { if (el.tagName === level) el.classList.add('pol-h'); });

    /* a lone heading above the first section is the document restating its own
       name — the page already carries that as its <h1>, so it becomes the
       standfirst rather than a section of its own */
    var firstSection = rte.querySelector('.pol-h');
    native.forEach(function (el) {
      if (el.classList.contains('pol-h')) return;
      var above = firstSection &&
        (el.compareDocumentPosition(firstSection) & Node.DOCUMENT_POSITION_FOLLOWING);
      if (!lead && above) {
        lead = el.textContent.replace(/\s+/g, ' ').trim();
        el.parentNode.removeChild(el);
      } else {
        el.classList.add('pol-sub');
      }
    });

  /* ── 1b. otherwise, bold lead-ins are the headings ─────────── */
  } else {
    Array.prototype.slice.call(rte.children).forEach(function (p) {
      if (p.tagName !== 'P') return;
      var first = p.firstChild;
      while (first && first.nodeType === 3 && !first.textContent.trim()) first = first.nextSibling;
      if (!first || first.nodeType !== 1) return;
      if (first.tagName !== 'STRONG' && first.tagName !== 'B') return;

      var label = first.textContent.replace(/\s+/g, ' ').trim();
      /* a bold run ending in a colon is an emphasis inside a sentence, not a
         heading, and a heading is never longer than a line */
      if (!label || label.length > 80 || /[:,;]$/.test(label)) return;

      var h = document.createElement('h2');
      h.className = 'pol-h';
      h.textContent = label;
      p.parentNode.insertBefore(h, p);
      first.parentNode.removeChild(first);

      while (p.firstChild && ((p.firstChild.nodeType === 3 && !p.firstChild.textContent.trim()) ||
             (p.firstChild.nodeType === 1 && p.firstChild.tagName === 'BR'))) {
        p.removeChild(p.firstChild);
      }
      if (!p.textContent.trim() && !p.querySelector('a,img')) p.parentNode.removeChild(p);
    });

    var firstEl = rte.firstElementChild;
    if (firstEl && firstEl.classList.contains('pol-h')) {
      lead = firstEl.textContent;
      firstEl.parentNode.removeChild(firstEl);
    }
  }

  var sections = [];

  /* ── 2. group the run into numbered sections ───────────────── */
  /* A short policy — a contact address, say — has nothing to number. It still
     gets the masthead, the two columns and the sidebar below. */
  if (rte.querySelectorAll('.pol-h').length) {
    /* the rules between sections are drawn by the layout now */
    Array.prototype.slice.call(rte.children).forEach(function (el) {
      if (el.tagName === 'HR') el.parentNode.removeChild(el);
    });

    var kids = Array.prototype.slice.call(rte.childNodes);
    var frag = document.createDocumentFragment();
    var current = document.createElement('div');
    current.className = 'pol-intro';
    frag.appendChild(current);
    var n = 0;

    kids.forEach(function (node) {
      if (node.nodeType === 1 && node.classList && node.classList.contains('pol-h')) {
        n++;
        /* headings that number themselves keep their own number */
        var raw = node.textContent.replace(/\s+/g, ' ').trim();
        var m = raw.match(/^(\d{1,2})\s*[.)]\s+/);
        var num = m ? m[1] : String(n);
        if (m) node.textContent = raw.slice(m[0].length);

        var sec = document.createElement('section');
        sec.className = 'pol-sec';
        sec.id = 'policy-' + n;
        var head = document.createElement('div');
        head.className = 'pol-sec-head';
        var no = document.createElement('span');
        no.className = 'no mono';
        no.textContent = (num.length < 2 ? '0' : '') + num + '/';
        head.appendChild(no);
        head.appendChild(node);
        sec.appendChild(head);
        frag.appendChild(sec);
        sections.push({ id: sec.id, label: node.textContent, no: no.textContent, el: sec });
        current = sec;
        return;
      }
      if (node.nodeType === 3 && !node.textContent.trim()) return;
      current.appendChild(node);
    });

    rte.innerHTML = '';
    rte.appendChild(frag);
    var intro = rte.querySelector('.pol-intro');
    if (intro && !intro.childNodes.length) rte.removeChild(intro);
  } else {
    document.body.classList.add('policy-short');
  }

  /* ── 3. masthead: where you are, what this is ────────────── */
  if (titleWrap) {
    var crumbs = document.createElement('div');
    crumbs.className = 'pol-crumbs mono';
    crumbs.innerHTML = '<a href="/">' + (document.title.split('–').pop() || 'FUKUI').trim() + '</a>' +
      '<span>/</span><span>Legal</span>';
    titleWrap.insertBefore(crumbs, titleWrap.firstChild);

    if (lead) {
      var leadEl = document.createElement('p');
      leadEl.className = 'pol-lead';
      leadEl.textContent = lead;
      titleWrap.appendChild(leadEl);
    }
  }

  /* ── 4. two columns, with the contents pinned beside the text ── */
  var grid = document.createElement('div');
  grid.className = 'pol-grid';
  var main = document.createElement('article');
  main.className = 'pol-main';
  var side = document.createElement('aside');
  side.className = 'pol-side';

  bodyEl.parentNode.insertBefore(grid, bodyEl);
  main.appendChild(bodyEl);
  grid.appendChild(main);
  grid.appendChild(side);

  if (sections.length > 2) {
    var toc = document.createElement('nav');
    toc.className = 'pol-toc';
    toc.setAttribute('aria-label', 'On this page');
    toc.innerHTML = '<div class="h mono">on this page</div><ol>' + sections.map(function (s) {
      return '<li><a href="#' + s.id + '" data-sec="' + s.id + '">' +
        '<span class="mono">' + s.no + '</span>' + s.label + '</a></li>';
    }).join('') + '</ol>';
    side.appendChild(toc);

    /* the header is sticky, so anchors need to land below it */
    toc.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-sec]');
      if (!a) return;
      var target = document.getElementById(a.dataset.sec);
      if (!target) return;
      e.preventDefault();
      var y = target.getBoundingClientRect().top + window.scrollY - 84;
      window.scrollTo({ top: y, behavior: 'smooth' });
      history.replaceState(null, '', '#' + a.dataset.sec);
    });

    if ('IntersectionObserver' in window) {
      var links = {};
      toc.querySelectorAll('a[data-sec]').forEach(function (a) { links[a.dataset.sec] = a; });
      var seen = {};
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { seen[en.target.id] = en.isIntersecting; });
        var active = sections.filter(function (s) { return seen[s.id]; })[0];
        Object.keys(links).forEach(function (id) {
          links[id].classList.toggle('on', !!active && active.id === id);
        });
      }, { rootMargin: '-90px 0px -70% 0px' });
      sections.forEach(function (s) { spy.observe(s.el); });
    }
  }

  /* ── 5. a way out of the page: ask a person, or read the rest ── */
  var mail = (rte.textContent.match(/[\w.+-]+@[\w-]+\.[a-z]{2,}/i) || [])[0];
  var card = document.createElement('div');
  card.className = 'pol-card';
  card.innerHTML = '<div class="h mono">a question this does not answer?</div>' +
    '<p>Write to us and a person replies — we would rather sort it out before you order than after.</p>' +
    (mail ? '<a class="btn" href="mailto:' + mail + '"><span>' + mail + '</span> →</a>' : '');
  side.appendChild(card);

  var linksEl = document.getElementById('polLinks');
  if (linksEl) {
    try {
      var all = JSON.parse(linksEl.textContent) || [];
      var here = window.location.pathname;
      /* skip this page, and skip "Cookie preferences", which is a banner
         trigger rather than a document to read */
      var others = all.filter(function (p) {
        return p.url && p.url !== here && p.url.indexOf('#') < 0;
      });
      if (others.length) {
        var nav = document.createElement('div');
        nav.className = 'pol-more';
        nav.innerHTML = '<div class="h mono">the rest of the small print</div>' +
          others.map(function (p) { return '<a href="' + p.url + '">' + p.title + ' →</a>'; }).join('');
        side.appendChild(nav);
      }
    } catch (e) {}
  }
})();
